import React from 'react';
import MachineList from './MachineList';
import VehiclePieChart from './VehiclePieChart';
import MachineStatusPieChart from './MachineStatusPieChart';
import Environment from './Environment';
import RebootAll3dApp from './RebootAll3dApp';
import RestartMachine from './RestartMachine';
import UpdateApplications from './UpdateApplications';
import DeploymentManager from './DeploymentManager'
import './telemetry.css';
import { getApiPath, getMachineDcGroups } from './util';
import { iMachineProps } from './Machine';

interface iTelemetryState {
  responseData: iMachineProps[];
}

class Telemetry extends React.Component<{}, iTelemetryState> {
  timer?: ReturnType<typeof setInterval>;

  constructor(props: {}) {
    super(props)

    this.state = {
      responseData: [],
    };
  }

  async callBackend(){
    const response = await fetch(getApiPath());
    const json = await response.json();
    this.setState({ responseData: json });
  }

  componentDidMount() {
    this.callBackend() // get a call off without delay
    this.timer = setInterval(() => this.callBackend(), 5000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }


  render() {
    if( this.state.responseData == null ||
         this.state.responseData.length === 0){
      return <div className="loading">
              <h1>Loading...</h1>
              </div>
    } else{

      const datacenters = Object.keys(getMachineDcGroups(this.state.responseData));
      return <div>
              <div className="headline">
                    <Environment />
              </div>
              <div>
                  <div className="upperSummary">
                    <div>
                      <VehiclePieChart pieChart={this.state.responseData}/>
                      <h2 className="pieChartName">
                        Current Streaming Vehicle
                      </h2>
                    </div>
                    <div>
                      <MachineStatusPieChart pieChart={this.state.responseData} />
                      <h2 className="pieChartName">
                        Application Status
                      </h2>
                    </div>
                    <div className="updateContainer">
                      <div>
                        <UpdateApplications UpdateApplications={this.state.responseData} datacenters={datacenters}/>
                      </div>
                      <div>
                        <h2>Restart Scripts</h2>
                        <RebootAll3dApp machineList={this.state.responseData}/>
                        <RestartMachine machineList={this.state.responseData}/>
                      </div>

                      <DeploymentManager DeploymentManager={this.state.responseData} datacenters={datacenters}/>
                    </div>
                  </div>
                  <div>
                     <MachineList machines={this.state.responseData}/>
                  </div>
              </div>
            </div>
    }
  }
}

export default Telemetry;
